export enum responsiveEndpointsEnum {
  XS = 480,
  SM = 575,
  MD = 768,
  LG = 1180,
  LG_L = 1515,
  XL = 1600,
}
